import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { useHover } from 'usehooks-ts';
import { Image } from '@lt/components';
import { Virtual, Pagination } from 'swiper';
import { getPictureProps } from './utils';
import type { HotelImage } from '../../types';
import NavigationButton from './components/NavigationButton/NavigationButton';

import 'swiper/swiper-bundle.css';
import styles from './hotelCardGallery.module.css';

type HotelCardGalleryProps = {
  images: HotelImage[];
  isMobile: boolean;
  isMapCard: boolean;
};

const HotelCardGallery: React.FC<HotelCardGalleryProps> = (props) => {
  const { images, isMobile, isMapCard } = props;

  const galleryRef = React.useRef(null);

  const isGalleryHovered = useHover(galleryRef);

  return (
    <div
      className={classNames(styles.galleryContainer, {
        [styles.galleryContainerDesktop]: !isMobile,
        [styles.galleryContainerMapCard]: !isMobile && isMapCard,
      })}
    >
      <Swiper
        ref={galleryRef}
        virtual
        allowSlideNext={images.length > 1}
        allowSlidePrev={images.length > 1}
        loop
        modules={[Virtual, Pagination]}
        pagination={
          isMobile
            ? {
                dynamicBullets: true,
              }
            : false
        }
        className={styles.gallery}
      >
        {images.map((image, index) => {
          const pictureProps = getPictureProps(image);

          return (
            <SwiperSlide key={pictureProps.src} virtualIndex={index}>
              <Image {...pictureProps} className={styles.styledPicture} />
              <div className="swiper-lazy-preloader" />
            </SwiperSlide>
          );
        })}

        {!isMobile && isGalleryHovered && images.length > 1 && (
          <>
            <NavigationButton direction="prev" />
            <NavigationButton direction="next" />
          </>
        )}

        <div
          className={classNames(styles.galleryOverlay, {
            [styles.galleryOverlayMobile]: isMobile,
            [styles.galleryOverlayDesktop]: !isMobile,
          })}
        />
      </Swiper>
    </div>
  );
};

export default HotelCardGallery;
